import {
  Assessment as AssessmentIcon,
  RateReview as RateReviewIcon,
  Try as TryIcon,
} from '@mui/icons-material'
import { Button, Stack, Tooltip } from '@mui/material'

import { checkPermissions } from '@rest/Utils'

/**
 * @component
 * @param {Object} props - The props for the component.
 * @param {Object} props.params
 * @param {Object} props.params.row
 * @param {string} [props.params.formattedValue]
 * @param {function} props.setActiveInstance
 * @param {function} props.setNoiseFeedbackOpen
 * @param {function} props.setCommentsFormOpen
 * @param {function} props.setAdjustFormOpen
 * @param {function} props.setPostFormOpen
 * @param {function} props.setEventReportOpen
 * @param {string[]} props.activePermissions
 */
export default function EventListActionCell({
  params,
  setActiveInstance,
  setNoiseFeedbackOpen,
  setCommentsFormOpen,
  setAdjustFormOpen,
  setPostFormOpen,
  setEventReportOpen,
  activePermissions,
}) {
  const { row } = params

  const feedbackPermissions = ['change_event_feedback']
  let buttonProps = {
    fullWidth: true,
    variant: 'contained',
    startIcon: <TryIcon />,
    size: 'small',
    sx: { width: 1, justifyContent: 'center' },
  }
  let label = ''

  if (row.eventClass === 'NOISE') {
    buttonProps = {
      ...buttonProps,
      startIcon: <RateReviewIcon />,
      onClick: () => {
        setActiveInstance(row)
        setNoiseFeedbackOpen(true)
      },
    }
    label = row.noiseFeedback ? 'Adjust' : 'Feedback'
  } else if (row.eventClass === 'SMOKE') {
    if (row.eventType === 'EXTERNAL') {
      if (row.feedbackOn) {
        buttonProps = {
          ...buttonProps,
          startIcon: <RateReviewIcon />,
          onClick: () => {
            setActiveInstance(row)
            setAdjustFormOpen(true)
          },
        }
        label = 'Adjust'
      } else {
        buttonProps.onClick = () => {
          setActiveInstance(row)
          setPostFormOpen(true)
        }
        label = 'Post'
      }
    } else {
      buttonProps.onClick = () => {
        setActiveInstance(row)
        setCommentsFormOpen(true)
      }
      label = 'Comment'
    }
  }

  const hasPermissions = checkPermissions(feedbackPermissions, activePermissions)

  const { endTime, eventClass } = row

  return (
    <Stack direction="row" spacing={1} justifyContent="flex-end" width="100%">
      <Button {...buttonProps} disabled={!hasPermissions}>
        {label}
      </Button>
      <Tooltip title={!endTime ? 'Report not yet available' : undefined}>
        <span style={{ width: '100%' }}>
          <Button
            {...buttonProps}
            variant="outlined"
            startIcon={<AssessmentIcon />}
            color="secondary"
            onClick={() => {
              setEventReportOpen(true)
              setActiveInstance(row)
            }}
            disabled={!endTime || (eventClass !== 'SMOKE' && eventClass !== 'NOISE')}
          >
            Report
          </Button>
        </span>
      </Tooltip>
    </Stack>
  )
}
